export const IrisLoginMethod = Object.freeze({
	Forms: 1,
	Windows: 2,
	SingleSignOn: 3,
});
